import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Button, Menu, MenuItem, Tooltip } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import TableRowProfile from "../../util/TableRowProfile";
import ConfirmationModal from "../../modal/ConfirmationModal";
import InvoiceVenueActModal from "./InvoiceVenueActModal";
import HGSuperPayEmployeeModal from "../../superPay/HGSuperPayEmployeeModal";
import ActDocumentsModal from "../../agent/actroster/ActDocumentsModal";
import ActImagesModal from "../../agent/actroster/ActImagesModal";
import image from "../../../helper/image";
import moment from "moment";
import "./StaffActRoster.css";
import { getActGenreNames } from "../../agent/actroster/genres";

const legalEntityLabels = {
    0: "Not Set",
    1: "Sole Trader",
    2: "Partnership",
    3: "Company",
    4: "Trust",
    5: "Hobbyist"
};

const vibesColorMap = {
    "Chilled": { bg: "#e0f2f1", color: "#00695c" },
    "Relaxed": { bg: "#e0f2f1", color: "#00695c" },
    "Acoustic": { bg: "#e8f5e9", color: "#2e7d32" },
    "Easy Listening": { bg: "#e8f5e9", color: "#2e7d32" },
    "Middle of the Road": { bg: "#fff8e1", color: "#f57c00" },
    "Upbeat": { bg: "#fff3e0", color: "#e65100" },
    "Party": { bg: "#fce4ec", color: "#c2185b" },
    "High Energy": { bg: "#fce4ec", color: "#c2185b" },
    "Dance": { bg: "#f3e5f5", color: "#7b1fa2" },
    "Club": { bg: "#f3e5f5", color: "#7b1fa2" },
    "Rock": { bg: "#ffebee", color: "#c62828" },
    "Alternative": { bg: "#ffebee", color: "#c62828" },
    "Jazz": { bg: "#e8eaf6", color: "#3949ab" },
    "Blues": { bg: "#e3f2fd", color: "#1565c0" },
    "Soul": { bg: "#ede7f6", color: "#5e35b1" },
    "R&B": { bg: "#ede7f6", color: "#5e35b1" },
    "Country": { bg: "#efebe9", color: "#5d4037" },
    "Folk": { bg: "#efebe9", color: "#5d4037" },
    "Classical": { bg: "#eceff1", color: "#455a64" },
    "Elegant": { bg: "#eceff1", color: "#455a64" },
    "Pop": { bg: "#e1f5fe", color: "#0277bd" },
    "Top 40": { bg: "#e1f5fe", color: "#0277bd" },
    "Covers": { bg: "#f1f8e9", color: "#558b2f" },
    "Originals": { bg: "#fff9c4", color: "#9e9d24" },
    "default": { bg: "#f5f5f5", color: "#616161" }
};

const getVibeColor = (vibe) => {
    return vibesColorMap[vibe] || vibesColorMap["default"];
};

@inject("venueActStore", "templateStore", "profileStore")
@withRouter
@observer
class StaffActRosterTable extends Component {
    state = {
        actionAnchor: [],
        vibesPopover: [],
        removeConfirmationModalState: false,
        selectedRoster: null,
        openActInvoiceSetting: false,
        venueAct: undefined,
        openSuperLedgerDetailsModal: false,
        employeeModalContactId: null,
        employeeModalContactName: "",
        documentsModalOpen: false,
        imagesModalOpen: false,
        selectedAct: null
    };

    setActionAnchor = (element, id) => {
        const tempAnchor = [];
        tempAnchor[id] = element;
        this.setState({ actionAnchor: tempAnchor });
    };

    unsetActionAnchor = () => {
        this.setState({ actionAnchor: [] });
    };

    toggleVibesPopover = (id) => {
        const { vibesPopover } = this.state;
        const newPopover = [...vibesPopover];
        newPopover[id] = !newPopover[id];
        this.setState({ vibesPopover: newPopover });
    };

    closeVibesPopover = (id) => {
        const { vibesPopover } = this.state;
        const newPopover = [...vibesPopover];
        newPopover[id] = false;
        this.setState({ vibesPopover: newPopover });
    };

    parseVibes = (vibesName) => {
        if (!vibesName) return [];
        return vibesName.split(",").map(v => v.trim()).filter(v => v);
    };

    getLegalEntityLabel = (legalEntity) => {
        return legalEntityLabels[legalEntity] || "Not Set";
    };

    createBooking = (actId, venueId) => {
        const redirectUrl = `/booking/new?actId=${actId}&venueId=${venueId}&dateStart=${moment(new Date()).format("DD-MM-YYYY")}`;
        this.props.history.push(redirectUrl);
    };

    handleButtonMessage = (act) => {
        this.props.profileStore.getProfileByIdSimple(act.actAdminId).then((result) => {
            this.props.history.push({
                pathname: '/messages/new',
                state: { profile: result }
            });
        });
    };

    handleOpenActInvoiceSetting = (data) => {
        this.setState({
            openActInvoiceSetting: true,
            venueAct: data
        });
    };

    handleCloseActInvoiceSetting = () => {
        this.setState({
            openActInvoiceSetting: false,
            venueAct: undefined
        });
    };

    openSuperLedgerPreviewDetails = (act) => {
        this.setState({
            openSuperLedgerDetailsModal: true,
            employeeModalContactId: act.actAdmin ? act.actAdmin.id : null,
            employeeModalContactName: act.actAdmin
                ? (act.actAdmin.profileName || `${act.actAdmin.firstName || ""} ${act.actAdmin.lastName || ""}`.trim())
                : ""
        });
    };

    closeSuperLedgerDetailsModal = () => {
        this.setState({
            openSuperLedgerDetailsModal: false,
            employeeModalContactId: null,
            employeeModalContactName: ""
        });
    };

    openRemoveModal = (roster) => {
        this.setState({
            removeConfirmationModalState: true,
            selectedRoster: roster
        });
    };

    closeRemoveModal = () => {
        this.setState({
            removeConfirmationModalState: false,
            selectedRoster: null
        });
    };

    handleRemove = () => {
        const { selectedRoster } = this.state;
        if (selectedRoster) {
            this.props.venueActStore.deleteVenueFavouriteAct(selectedRoster.id).then(() => {
                this.props.templateStore.openSnackbar("Act has been removed from roster.");
                this.closeRemoveModal();
            });
        }
    };

    openDocumentsModal = (act) => {
        const ownerId = act?.myMusician?.id || act?.adminMusician?.id || act?.actAdmin?.id || act?.actAdminId || act?.id;
        if (!ownerId) {
            this.props.templateStore.openSnackbar("Unable to load documents - act owner not found");
            return;
        }
        this.setState({
            documentsModalOpen: true,
            selectedAct: act
        });
    };

    closeDocumentsModal = () => {
        this.setState({
            documentsModalOpen: false,
            selectedAct: null
        });
    };

    openImagesModal = (act) => {
        if (!act?.id) {
            this.props.templateStore.openSnackbar("Unable to load images - act not found");
            return;
        }
        this.setState({
            imagesModalOpen: true,
            selectedAct: act
        });
    };

    closeImagesModal = () => {
        this.setState({
            imagesModalOpen: false,
            selectedAct: null
        });
    };

    getFilteredRosters = () => {
        const { paginatedRosters, venueActStore, selectedVenueId } = this.props;
        
        if (paginatedRosters) {
            return paginatedRosters;
        }
        
        const { venueActRoster } = venueActStore;

        if (!venueActRoster || venueActRoster.length === 0) return [];
        
        if (selectedVenueId === "all") {
            return venueActRoster;
        }

        const selectedId = String(selectedVenueId);
        return venueActRoster.filter(roster => {
            const rosterId = String(roster.venueId || roster.venue?.id || '');
            return rosterId === selectedId;
        });
    };

    render() {
        const { allowBooking } = this.props;
        const { actionAnchor, vibesPopover } = this.state;
        const rosters = this.getFilteredRosters();

        if (!rosters || rosters.length === 0) {
            return (
                <div className="staff-roster-empty">
                    <i className="fa fa-search"></i>
                    <p>No acts found matching your criteria.</p>
                    <p style={{ fontSize: 14, marginTop: 8 }}>Try adjusting your search or filters.</p>
                </div>
            );
        }

        return (
            <Fragment>
                <div className="staff-act-roster-table-container">
                    <table className="staff-act-roster-table">
                        <thead>
                            <tr>
                                <th style={{ width: "18%" }}>Act</th>
                                <th style={{ width: "12%" }}>Venue</th>
                                <th style={{ width: "12%" }}>Type & Lineup</th>
                                <th style={{ width: "14%" }}>Vibes/Genres</th>
                                <th style={{ width: "18%" }}>Super/Invoicing</th>
                                <th style={{ width: "16%" }}>Contact</th>
                                <th style={{ width: "10%" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rosters.map((roster, index) => {
                                const act = roster.act;
                                const venue = roster.venue;
                                if (!act) return null;

                                const vibes = this.parseVibes(act.vibesName);
                                const genres = getActGenreNames(act, this.props.genreCatalog || []);
                                const allTags = [...vibes.map(v => ({ type: 'vibe', value: v })), ...genres.map(g => ({ type: 'genre', value: g }))];
                                const visibleTags = allTags.slice(0, 3);
                                const remainingTagsCount = allTags.length - 3;
                                const legalEntityLabel = this.getLegalEntityLabel(act?.actAdmin?.legalEntity);
                                const isSuperComplete = act.isSuperCompleted;
                                const isPlayerInvoicesEnabled = roster.invoiceType === 1;
                                const isLegalEntitySet = act?.actAdmin?.legalEntity && act?.actAdmin?.legalEntity !== 0;
                                const rowId = roster.id || index;

                                return (
                                    <tr key={rowId}>
                                        <td data-label="Act">
                                            <div className="staff-act-cell">
                                                <TableRowProfile
                                                    profileId={act.id}
                                                    name={act.actName || act.fullName}
                                                    avatarUrl={image.getProfileImage(act)}
                                                />
                                                <div className="act-owner">
                                                    by {act.myMusician?.fullName || "Unknown"}
                                                </div>
                                            </div>
                                        </td>
                                        <td data-label="Venue">
                                            <div className="staff-venue-cell">
                                                <img
                                                    src={image.getProfileImage(venue)}
                                                    className="venue-avatar"
                                                    alt=""
                                                    onError={(e) => { e.target.style.display = 'none'; }}
                                                />
                                                <span className="venue-name">
                                                    {venue?.fullName || venue?.profileName || "-"}
                                                </span>
                                            </div>
                                        </td>
                                        <td data-label="Type & Lineup">
                                            <div className="staff-chip-group">
                                                {act.actTypeName && (
                                                    <span className="staff-chip staff-chip-type">{act.actTypeName}</span>
                                                )}
                                                {act.lineupCountName && (
                                                    <span className="staff-chip staff-chip-lineup">{act.lineupCountName}</span>
                                                )}
                                                {!act.actTypeName && !act.lineupCountName && (
                                                    <span className="staff-chip staff-chip-empty">-</span>
                                                )}
                                            </div>
                                        </td>
                                        <td data-label="Vibes/Genres">
                                            <div className="staff-chip-group staff-vibes-cell">
                                                {visibleTags.map((tag, i) => {
                                                    if (tag.type === 'vibe') {
                                                        const vibeColor = getVibeColor(tag.value);
                                                        return (
                                                            <span
                                                                key={i}
                                                                className="staff-chip"
                                                                style={{ background: vibeColor.bg, color: vibeColor.color }}
                                                            >
                                                                {tag.value}
                                                            </span>
                                                        );
                                                    } else {
                                                        return (
                                                            <span key={i} className="staff-chip staff-chip-genre">
                                                                {tag.value}
                                                            </span>
                                                        );
                                                    }
                                                })}
                                                {remainingTagsCount > 0 && (
                                                    <Fragment>
                                                        <span
                                                            className="staff-chip staff-chip-more"
                                                            onClick={() => this.toggleVibesPopover(rowId)}
                                                        >
                                                            +{remainingTagsCount} more
                                                        </span>
                                                        {vibesPopover[rowId] && (
                                                            <Fragment>
                                                                <div
                                                                    className="staff-vibes-popover-overlay"
                                                                    onClick={() => this.closeVibesPopover(rowId)}
                                                                />
                                                                <div className="staff-vibes-popover">
                                                                    {vibes.length > 0 && (
                                                                        <>
                                                                            <div className="staff-vibes-popover-header">Vibes</div>
                                                                            <div className="staff-vibes-popover-list">
                                                                                {vibes.map((vibe, i) => {
                                                                                    const vibeColor = getVibeColor(vibe);
                                                                                    return (
                                                                                        <span
                                                                                            key={i}
                                                                                            className="staff-chip"
                                                                                            style={{ background: vibeColor.bg, color: vibeColor.color }}
                                                                                        >
                                                                                            {vibe}
                                                                                        </span>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                    {genres.length > 0 && (
                                                                        <>
                                                                            <div className="staff-vibes-popover-header" style={{ borderTop: vibes.length > 0 ? '1px solid #eee' : 'none' }}>Genres</div>
                                                                            <div className="staff-vibes-popover-list">
                                                                                {genres.map((genre, i) => (
                                                                                    <span key={i} className="staff-chip staff-chip-genre">{genre}</span>
                                                                                ))}
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </Fragment>
                                                        )}
                                                    </Fragment>
                                                )}
                                                {allTags.length === 0 && (
                                                    <span className="staff-chip staff-chip-empty">-</span>
                                                )}
                                            </div>
                                        </td>
                                        <td data-label="Super/Invoicing">
                                            <div className="staff-status-badges">
                                                <Tooltip title={`Legal Entity: ${legalEntityLabel}`}>
                                                    <span className={`staff-status-badge ${isLegalEntitySet ? "complete" : "not-set"}`}>
                                                        <i className="fa fa-building"></i>
                                                        {legalEntityLabel}
                                                    </span>
                                                </Tooltip>
                                                <Tooltip title={isSuperComplete ? "Superannuation details have been submitted" : "Superannuation details not yet submitted"}>
                                                    <span className={`staff-status-badge ${isSuperComplete ? "complete" : "not-set"}`}>
                                                        <i className={`fa ${isSuperComplete ? "fa-check-circle" : "fa-minus-circle"}`}></i>
                                                        {isSuperComplete ? "Super Details Added" : "Super Not Set"}
                                                    </span>
                                                </Tooltip>
                                                <Tooltip title={isPlayerInvoicesEnabled ? "You will receive invoices from players of this act" : "Invoice setting not configured"}>
                                                    <span className={`staff-status-badge ${isPlayerInvoicesEnabled ? "complete" : "not-set"}`}>
                                                        <i className={`fa ${isPlayerInvoicesEnabled ? "fa-check-circle" : "fa-minus-circle"}`}></i>
                                                        {isPlayerInvoicesEnabled ? "Player Invoices Enabled" : "Player Invoices Not Set"}
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        </td>
                                        <td data-label="Contact">
                                            <div className="staff-contact-chips">
                                                {(act.contactPhone || act.actAdmin?.phone) && (
                                                    <a href={`tel:${act.contactPhone || act.actAdmin?.phone}`} className="staff-contact-chip phone">
                                                        <i className="fa fa-phone"></i>
                                                        {act.contactPhone || act.actAdmin?.phone}
                                                    </a>
                                                )}
                                                {(act.contactEmail || act.actAdmin?.email) && (
                                                    <a href={`mailto:${act.contactEmail || act.actAdmin?.email}`} className="staff-contact-chip email">
                                                        <i className="fa fa-envelope"></i>
                                                        {act.contactEmail || act.actAdmin?.email}
                                                    </a>
                                                )}
                                                {!act.contactPhone && !act.actAdmin?.phone && !act.contactEmail && !act.actAdmin?.email && (
                                                    <span className="staff-contact-chip empty">No contact info</span>
                                                )}
                                            </div>
                                        </td>
                                        <td data-label="Actions">
                                            {allowBooking && (
                                                <Fragment>
                                                    <Button
                                                        className="gig-actions-dropdown-btn"
                                                        onClick={(e) => this.setActionAnchor(e.currentTarget, rowId)}
                                                    >
                                                        Actions <ArrowDropDownIcon />
                                                    </Button>
                                                    <Menu
                                                        open={actionAnchor[rowId] != null}
                                                        onClose={this.unsetActionAnchor}
                                                        anchorEl={actionAnchor[rowId]}
                                                        getContentAnchorEl={null}
                                                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                    >
                                                        <MenuItem
                                                            onClick={() => { this.unsetActionAnchor(); this.createBooking(act?.id, roster.venueId); }}
                                                            className="staff-menu-item-primary"
                                                        >
                                                            <i className="fa fa-plus staff-menu-icon"></i>
                                                            Create Booking
                                                        </MenuItem>
                                                        <div className="staff-menu-divider" />
                                                        <MenuItem onClick={() => { this.unsetActionAnchor(); this.handleButtonMessage(act); }}>
                                                            <i className="fa fa-envelope staff-menu-icon"></i>
                                                            Send Message
                                                        </MenuItem>
                                                        <div className="staff-menu-divider" />
                                                        <MenuItem
                                                            onClick={() => { this.unsetActionAnchor(); this.openDocumentsModal(act); }}
                                                            className="staff-menu-item-new"
                                                        >
                                                            <i className="fa fa-folder-open staff-menu-icon"></i>
                                                            View Documents
                                                        </MenuItem>
                                                        <MenuItem
                                                            onClick={() => { this.unsetActionAnchor(); this.openImagesModal(act); }}
                                                            className="staff-menu-item-new"
                                                        >
                                                            <i className="fa fa-image staff-menu-icon"></i>
                                                            Download Images
                                                        </MenuItem>
                                                        <div className="staff-menu-divider" />
                                                        <MenuItem onClick={() => { this.unsetActionAnchor(); this.handleOpenActInvoiceSetting(roster); }}>
                                                            <i className="fa fa-file-invoice staff-menu-icon"></i>
                                                            Update Invoice Setting
                                                        </MenuItem>
                                                        <MenuItem onClick={() => { this.unsetActionAnchor(); this.openSuperLedgerPreviewDetails(act); }}>
                                                            <i className="fa fa-coins staff-menu-icon"></i>
                                                            View Super Account Details
                                                        </MenuItem>
                                                        <div className="staff-menu-divider" />
                                                        <MenuItem
                                                            onClick={() => { this.unsetActionAnchor(); this.openRemoveModal(roster); }}
                                                            className="staff-menu-item-danger"
                                                        >
                                                            <i className="fa fa-trash staff-menu-icon"></i>
                                                            Remove from Roster
                                                        </MenuItem>
                                                    </Menu>
                                                </Fragment>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                <ConfirmationModal
                    open={this.state.removeConfirmationModalState}
                    title="Remove Act from Roster"
                    message={`Are you sure you want to remove ${this.state.selectedRoster?.act?.actName || 'this act'} from your roster?`}
                    closeHandler={this.closeRemoveModal}
                    confirmationHandler={this.handleRemove}
                    declineHandler={this.closeRemoveModal}
                    confirmationLabel="Remove"
                />

                <InvoiceVenueActModal
                    open={this.state.openActInvoiceSetting}
                    data={this.state.venueAct}
                    onClose={this.handleCloseActInvoiceSetting}
                />

                <HGSuperPayEmployeeModal
                    open={this.state.openSuperLedgerDetailsModal}
                    onClose={this.closeSuperLedgerDetailsModal}
                    contactId={this.state.employeeModalContactId}
                    employerProfileId={this.props.profileStore.currentProfile ? this.props.profileStore.currentProfile.id : null}
                    contactName={this.state.employeeModalContactName}
                    showActions={false}
                />

                <ActDocumentsModal
                    open={this.state.documentsModalOpen}
                    onClose={this.closeDocumentsModal}
                    act={this.state.selectedAct}
                />

                <ActImagesModal
                    open={this.state.imagesModalOpen}
                    onClose={this.closeImagesModal}
                    act={this.state.selectedAct}
                />
            </Fragment>
        );
    }
}

export default StaffActRosterTable;
